





























import Vue from 'vue'
import api from '@/api'

export default Vue.extend({
  data() {
    return {
      loading: false,
      credits: [] as any[],
      columns: [
        {
          label: 'N° de dossier',
          field: 'reference'
        },
        {
          label: 'Nom',
          field: 'beneficiary.name',
          searchable: true
        },
        {
          label: 'Sexe',
          field: 'beneficiary.gender'
        },
        {
          label: 'Numéro',
          field: 'beneficiary.phone'
        },
        {
          label: 'Montant',
          field: 'amount',
          currency: true
        },
        {
          label: 'Agence Responsable',
          field: 'agency'
        },
        {
          label: 'Etat',
          field: 'state'
        }
      ]
    }
  },

  computed: {
    creditLineId(): string {
      return this.$route.params.creditLineId
    },

    dispatchingCredits(this: any) {
      return this.credits
    }
  },

  created(this: any) {
    this.loading = true
    api
      .get('/dispatching-credits', {
        params: {
          creditLineId: this.creditLineId,
          otm: this.$route.query.otm,
          populate: 'creditLine,transaction,createdBy,beneficiary'
        }
      })
      .then((response: any) => {
        this.credits = response.data.result
        this.loading = false
      })
      .catch((error: Error) => {
        console.error(error)
        this.loading = false
      })
  }
})
